<template>
    <div>
        <div class="row">
            <div class="col-md-12 form-group">
                <div class="result-icon" v-if="resultItem.isCompleted">
                    <span class="text-success fa fa-thumbs-up fa-2x"></span>
                    {{$t('signing.isSigned')}}
                </div>
                <div class="result-icon" v-else>
                    <i class="text-primary fa fa-sync fa-2x fa-spin"></i>
                    {{$t('signing.ongoing')}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import signingService from '@/services/signing.service';

    export default {
        components: {},
        props: {
            signingId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                resultItem: {}
            };
        },
        methods: {
            async loadData() {
                try {
                    var result = await signingService.getResult(this.signingId);
                    this.resultItem = { ...result.data };
                } catch (err) {
                    this.$vs.notify({
                        color: 'danger',
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(err)
                    });
                }
            }
        },
        mounted() {
            this.loadData();
        }
    };
</script>

<style lang="scss" scoped>
    .result-item {
        border-bottom: 1px solid lightgrey;
    }

    .fa-2x {
        text-align: center;
        border: 2px solid #4caf50;
        border-radius: 50%;
        padding: 15px;
    }

        .fa-2x.text-danger {
            border-color: #f44336 !important;
        }

        .fa-2x.text-primary {
            border: none !important;
        }

    .result-icon {
        display: flex;
        flex-direction: column;
        width: fit-content;
        margin: 0 auto;
    }

    .list-item {
        border-bottom: 1px solid lightgrey;
        padding-bottom: 5px;
    }
</style>
